import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const dataFimAposDataInicioValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const inicio = group.get('dataInicio')?.value;
  const fim = group.get('dataFim')?.value;
  if (!inicio || !fim) return null;
  return fim > inicio ? null : {dataFimInvalida: true};
};

export const statusAlvoValidoValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const tipoMeta = group.get('tipoMeta')?.value;
  const statusAlvo = group.get('statusAlvo')?.value;
  const statusContribuintes: string[] = group.get('statusContribuintes')?.value ?? [];
  if (tipoMeta !== 'PERCENTUAL_STATUS') return null;
  return statusAlvo && statusContribuintes.includes(statusAlvo) ? null : {statusAlvoInvalido: true};
};

export const cursoAlvoValidoValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const tipoMeta = group.get('tipoMeta')?.value;
  const cursoAlvo = group.get('cursoAlvo')?.value;
  if (tipoMeta !== 'PROCESSOS_PENDENTES') return null;
  return cursoAlvo ? null : {cursoAlvoInvalido: true};
};
